// extracted by mini-css-extract-plugin
module.exports = {"pageContainer":"styles_pageContainer__2xvsi","title":"styles_title__2lZbd","scrollToTop":"styles_scrollToTop__1tt03"};